import { render, staticRenderFns } from "./withdrawalStatistics.vue?vue&type=template&id=131fe72c&scoped=true"
import script from "./withdrawalStatistics.vue?vue&type=script&lang=js"
export * from "./withdrawalStatistics.vue?vue&type=script&lang=js"
import style0 from "./withdrawalStatistics.vue?vue&type=style&index=0&id=131fe72c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131fe72c",
  null
  
)

export default component.exports